import { Component, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';
import { PagedSearch } from 'src/app/shared';
import { PledgeSearchDto } from 'src/app/revenue/shared/pledge/dto/pledge-search.dto';
import { PledgeService } from 'src/app/revenue/shared/pledge/pledge.service';
import { PledgeCampaignDto } from 'src/app/revenue/shared/pledge-campaign/dto/pledge-campaign.dto';
import { PledgeSeachResultDto } from 'src/app/revenue/shared/pledge/dto/pledge-search-result.dto';

@Component({
  selector: 'wl-pledge-campaign-details-edit-progressbar',
  templateUrl: './pledge-campaign-details-edit-progressbar.component.html',
  styleUrls: ['./pledge-campaign-details-edit-progressbar.component.less'],
  viewProviders: [],
    standalone: false
})
export class PledgeCampaignDetailsEditProgressbarComponent implements OnInit {
  @Input() pledgeCampaign: PledgeCampaignDto;
  pledges: PledgeSeachResultDto[] = [];
  pledgeSearch = new PagedSearch() as PledgeSearchDto;
  donorCount: number;
  totalPledged: number;
  timeRemaining: number;
  yearsRemaining: number;
  monthsRemaining: number;
  pledgeCampaignGoal: number;
  chartData: any;
  chartOptions: any;
  chartDataReady: boolean = false;
  campaignEndDatePassed: boolean = false;

  constructor(private _pledgeService: PledgeService) {}

  ngOnInit() {
    if (this.pledgeCampaign) {
      this.pledgeSearch.PledgeCampaignId = this.pledgeCampaign.PledgeCampaignId;
      this.configureComponentData();
    }
  }

  public configureComponentData() {
    this._pledgeService.searchPledges(this.pledgeSearch).then((data) => {
      this.chartDataReady = false;
      this.pledges = data.Result;
      this.pledgeCampaignGoal = this.pledgeCampaign.Goal;
      this.configureTotalPledged();
      this.configureDonorCount();
      this.configureEndDatePassed();
      this.configureYearAndMonthRemaining();
      this.configureChartData();
      this.configureChartOptions();
      this.chartDataReady = true;
    });
  }

  private configureTotalPledged() {
    if (this.pledges.length == 0) {
      this.totalPledged = 0;
    } else {
      this.totalPledged = this.pledges.map((x) => x.PledgeTotal ?? 0).reduce((sum, current) => sum + current);
    }
  }

  private configureDonorCount() {
    let uniqueDonorIds = this.pledges.map((x) => x.ProfileId ?? 0).filter((x) => x > 0);
    this.donorCount = new Set(uniqueDonorIds).size;
  }

  private configureEndDatePassed() {
    let today: Date = new Date();
    today.setHours(23, 59, 59, 59);
    let campaignEndDate: Date = this.pledgeCampaign.EndDate ?? new Date();
    let timeDifference: number = campaignEndDate.valueOf() - today.valueOf();
    if (timeDifference < -86400000) {
      this.campaignEndDatePassed = true;
    } else {
      this.campaignEndDatePassed = false;
      this.timeRemaining = timeDifference > 0 ? timeDifference : 0;
    }
  }

  private configureYearAndMonthRemaining() {
    this.yearsRemaining = Math.floor(this.timeRemaining / 31536000000);
    this.monthsRemaining = Math.floor(this.timeRemaining / 2629800000 - this.yearsRemaining * 12);
  }

  private configureChartData() {
    this.chartData = {
      labels: [this.pledgeCampaign.CampaignName],
      datasets: [
        {
          backgroundColor: '#0675aa',
          data: [this.totalPledged],
          barPercentage: 1.0,
          categoryPercentage: 1.0,
        },
      ],
    };
  }

  private configureChartOptions() {
    this.chartOptions = {
      layout: {
        autoPadding: false,
      },
      indexAxis: 'y',
      scales: {
        x: {
          max: this.pledgeCampaignGoal,
          grid: {
            display: false,
          },
          display: false,
        },
        y: {
          grid: {
            display: false,
          },
          display: false,
        },
      },
      plugins: {
        tooltip: {
          enabled: false,
        },
        legend: {
          display: false,
        },
        customCanvasBackgroundColor: {
          color: 'lightGreen',
        },
      },
    };
  }
}
